import * as types from "../types/unRegisterRider.types";
import moment from "moment";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
    date: [moment(), moment()],
  },
  initialSingle: [],
};
const UnRegisterRiderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_UN_REGISTER_RIDER_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_UN_REGISTER_RIDER_DETAIL_DATA:
      return { ...state, initialSingle: action.payload };
    case types.SET_UN_REGISTER_RIDER_LOADING:
      return { ...state, initialLoading: action.payload };
    case types.SET_UN_REGISTER_RIDER_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_UN_REGISTER_RIDER_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.RESET_UN_REGISTER_RIDER_REDUCER:
      return { 
        ...state, 
        initialData: [],
        initialSingleData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: {
          page: 1,
          limit: 10,
        },
        initialSingle: [],
      };
    default:
      return state;
  }
};
export default UnRegisterRiderReducer;
